import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import LanguageToggle from '../components/LanguageToggle';
import { useLanguage } from '../context/LanguageContext';
import styles from './ToolsPage.module.css';
import Navbar from '../components/Navbar';

const ToolsPage = () => {
  const { t } = useLanguage();

  const tools = [
    { icon: '📊', title: t('tool1Title', 'Brand Feedback Audit'), desc: t('tool1Desc', 'Quickly see how many of your online reviews have gone unanswered, and what a reply could be worth.'), link: '/audit' },
    { icon: '✍️', title: t('tool2Title', 'Smart Reply Generator'), desc: t('tool2Desc', 'Enter any customer comment to immediately draft a polite, brand-aligned response tailored to your tone.'), link: '#' },
    { icon: '⭐', title: t('tool3Title', 'Star Rating Goal Estimator'), desc: t('tool3Desc', 'Calculate precisely how many consecutive 5-star ratings are needed to raise your business profile to your target score.'), link: '#' },
    { icon: '📈', title: t('tool4Title', 'Response Impact Estimator'), desc: t('tool4Desc', 'Provide your typical transaction size to estimate the potential impact of unanswered reviews.'), link: '#' },
    { icon: '🛡️', title: t('tool5Title', 'HIPAA Safety Validator'), desc: t('tool5Desc', 'Paste your review reply to instantly scan for potential medical confidentiality or HIPAA exposure hazards.'), link: '#' },
    { icon: '📝', title: t('tool6Title', 'Review Request Copy Blueprints'), desc: t('tool6Desc', 'Copy-paste proven SMS and email templates to ask your customers for honest Google reviews.'), link: '#' },
  ];

  return (
    <div className={styles.page}>
      {/* Navbar */}
      <Navbar className={styles.navbar} innerClassName={styles.navInner} brandClassName={styles.navBrand} brand="ReplyShoot">
          <div className={styles.navLinks}>
            <Link to="/tools" className={styles.navLink}>{t('tools', 'Tools')}</Link>
            <LanguageToggle />
            <Link to="/audit" className={styles.navBtn}>{t('freeAudit', 'Free Audit')}</Link>
          </div>
      </Navbar>

      {/* Hero */}
      <header className={styles.hero}>
        <div className={styles.heroTag}>🔧 {t('toolsTag', 'Complimentary review tools for local businesses')}</div>
        <h1 className={styles.heroTitle}>{t('toolsTitle', 'Google Review Response Tools')}</h1>
        <p className={styles.heroSub}>
          {t('toolsSub', 'Professional tools designed to help you monitor, respond to, and stay on top of your Google reviews — at no extra cost.')}
        </p>
      </header>

      {/* Tools Grid */}
      <main className={styles.toolsGrid}>
        {tools.map((toolItem, idx) => (
          <div key={idx} className={styles.toolCard}>
            <div className={styles.toolIcon}>
              <span style={{ fontSize: '1.5rem' }}>{toolItem.icon}</span>
            </div>
            <h2 className={styles.title}>{toolItem.title}</h2>
            <p className={styles.desc}>{toolItem.desc}</p>
            <a href={toolItem.link} className={styles.toolLink}>{t('useTool', 'Use tool →')}</a>
          </div>
        ))}
      </main>

      <Footer />
    </div>
  );
};

export default ToolsPage;
